// @flow weak

import {
  compose,
  branch,
  withStateHandlers,
  renderNothing,
  lifecycle,
  mapProps,
} from 'recompose';
import MobileDetect from 'mobile-detect';
import * as R from 'ramda';

const md = new MobileDetect(window.navigator.userAgent);

const getOrientation = R.pipe(
  R.prop('orientation'),
  R.cond([
    // $FlowIssue
    [R.mathMod(R.__, 180), R.always('landscape')], // eslint-disable-line no-underscore-dangle
    [R.T, R.always('portrait')],
  ]),
);
let device = 'desktop';

if (md.tablet()) {
  device = 'tablet';
} else if (md.mobile()) {
  device = 'mobile';
}

export const withDevice = compose(
  withStateHandlers(
    { device: device, orientation: getOrientation(window) },
    {
      onChangeOrientation: state => e => {
        e && e.preventDefault();

        return { ...state, orientation: getOrientation(e.target) };
      },
    },
  ),
  lifecycle({
    componentDidMount() {
      window.addEventListener(
        'orientationchange',
        this.props.onChangeOrientation,
      );
    },
    componentWillUnmount() {
      window.removeEventListener(
        'orientationchange',
        this.props.onChangeOrientation,
      );
    },
  }),
  mapProps(({ onChangeOrientation, ...rest }) => ({
    ...rest,
  })),
);

export const Device = compose(
  withDevice,
  branch(({ children }) => !children, renderNothing),
)(({ children, ...rest }) => children(rest));
